import React from "react"
import PropTypes from 'prop-types'

import Grid from "./Grid"
import List from "./List"
import Calendar from "./Calendar"
import Building from "./Building"
import Group from "./Group"
import Marker from "./Marker"
import Search from "./Search"

const Icon = props => {
  switch (props.name) {
    case "grid":
      return <Grid {...props} />
    case "list":
      return <List {...props} />
    case "calendar":
      return <Calendar {...props} />
    case "building":
      return <Building {...props} />
    case "group":
      return <Group {...props} />
    case "marker":
      return <Marker {...props} />
    case "search":
      return <Search {...props} />
    default:
      return
  }
}

Icon.propTypes = {
  name: PropTypes.string
}

export default Icon
